export const APP = {
  name: process.env.REACT_APP_NAME || 'MyTownly Anna',
  version: process.env.REACT_APP_VERSION || '1.0.60',
  city: process.env.REACT_APP_CITY || 'Piler',
  state: process.env.REACT_APP_STATE || 'Andhra Pradesh',
  mapCenter: {
    lat: Number(process.env.REACT_APP_MAP_CENTER_LAT) || 13.6549,
    lng: Number(process.env.REACT_APP_MAP_CENTER_LNG) || 78.9471,
  },
  serviceRadiusKm: Number(process.env.REACT_APP_SERVICE_RADIUS_KM) || 5,
  supportPhone: process.env.REACT_APP_SUPPORT_PHONE || '7989020222',
  supportWhatsapp: process.env.REACT_APP_SUPPORT_WHATSAPP || '917989020222',
  /**
   * Admin dues payee — kept in one place so the number the Anna reads/copies
   * and the UPI ID their payment actually lands in can never drift apart.
   */
  duesPhone: process.env.REACT_APP_DUES_PHONE || '9491253045',
  duesUpiVpa: process.env.REACT_APP_DUES_UPI || '9491253045@ybl',
  duesPayeeName: process.env.REACT_APP_DUES_PAYEE_NAME || 'MyTownly Rides',
};

export const getDuesUpiUrl = (amount) => {
  const pa = encodeURIComponent(APP.duesUpiVpa);
  const pn = encodeURIComponent(APP.duesPayeeName);
  const base = `upi://pay?pa=${pa}&pn=${pn}&cu=INR`;
  const am = Number(amount);
  if (am > 0) return `${base}&am=${am.toFixed(2)}`;
  return base;
};

export const openDuesUpi = (amount) => {
  const url = getDuesUpiUrl(amount);
  // WebView-friendly: location change is more reliable than <a href="upi://…">
  try {
    window.location.href = url;
  } catch {
    window.open(url, '_blank');
  }
};

export const openNavigation = (lat, lng) => {
  if (lat == null || lng == null) return;
  const isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent || '');
  if (isAndroid) {
    try {
      window.location.href = `google.navigation:q=${lat},${lng}&mode=d`;
      return;
    } catch { /* fallback below */ }
  }
  const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`;
  window.open(url, '_blank', 'noopener,noreferrer');
};

/** Generates UPI payment URL for driver collection with exact ride amount */
export const getDriverUpiPayUrl = ({ upiId, name = 'Auto Captain', amount = 0, note = 'MyTownly Auto Trip' } = {}) => {
  if (!upiId) return '';
  const pa = encodeURIComponent(String(upiId).trim()).replace(/%40/g, '@');
  // pn / tn are display-only; cap them so the resulting URI can't overflow the
  // offline QR encoder's capacity (see QrCodeView getBestVersion).
  const pn = encodeURIComponent(String(name || 'Auto Captain').trim().slice(0, 32));
  const tn = encodeURIComponent(String(note || 'MyTownly Auto Trip').trim().slice(0, 24));
  const base = `upi://pay?pa=${pa}&pn=${pn}&tn=${tn}&cu=INR`;
  const am = Number(amount);
  if (am > 0) return `${base}&am=${am.toFixed(2)}`;
  return base;
};
